import { EventRegistry } from '../../../../../domain/event/event.registry';
import { AssetClassEvent } from './asset-class.event';
export class AssetsPurgedEvent extends AssetClassEvent {
    constructor(payload, metadata, fromPersistence) {
        super({
            subject: `asset-class/${payload.id}`,
            type: AssetsPurgedEvent.type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
AssetsPurgedEvent.type = 'com.treeplotter.api.asset-class.assetsPurged.v1';
EventRegistry.register(AssetsPurgedEvent.type, AssetsPurgedEvent);
//# sourceMappingURL=assets-purged.event.js.map